import React from "react";
import PropTypes from "prop-types";

import { Header, Icon } from "semantic-ui-react";

import { MailToMessage } from "scenes/Authentication/components/Layout/components";

function SuccessStep({ successShortMessage, successMessage }) {
  return (
    <div
      style={{ maxWidth: "650px", margin: "0px auto", textAlign: "center" }}
      data-test="success-step"
    >
      <Icon name="check circle" size="big" color="green" />
      <Header as="h2" data-test="success-short-message">
        {successShortMessage}
      </Header>
      <div style={{ marginTop: "1.5em" }} data-test="success-message">
        <MailToMessage keyword="feedback" subject="Change Plan Feedback">
          {successMessage}
        </MailToMessage>
      </div>
    </div>
  );
}

SuccessStep.propTypes = {
  successMessage: PropTypes.string,
  successShortMessage: PropTypes.string,
};

SuccessStep.defaultProps = { successMessage: "", successShortMessage: "" };

export default SuccessStep;
